import React from 'react';
import { Form, Input, Button } from 'antd';
import styled from 'styled-components';
import { PlusOutlineIcon, MinusOutlineIcon, PrimaryColor } from 'GlobalStyles';

const InterviewQuestionsInput = ({ fieldName }: { fieldName?: number }) => {
  return (
    <InterviewQuestionsInputWrapper>
      <Form.List name={fieldName !== undefined ? [fieldName, 'interview_question'] : 'interview_question'}>
        {(fields, { add, remove }, { errors }) => (
          <StyledQuestionListFormContainer>
            <StyledQuestionList>
              {fields.map((field, index) => (
                <StyledQuestion key={field.key}>
                  <Form.Item
                    className='form-item'
                    {...field} //이렇게 하면 따로 Form.List 하위 Form.Item 의 name을 부여할 필요가 없고 이대로 배열형태가 된다
                    rules={[{ required: true }]}
                  >
                    {/* <Input placeholder='질문을 적어주세요' /> */}
                    <Input.TextArea
                      placeholder={
                        index === 0
                          ? '컨설팅에 적합한 성격이 뭐라고 생각해요?'
                          : '금융그룹 계열사가 여러 개인데 서울 각지에 흩어져 있다. 한 경기도 시청에서 부지를 마련해 줄 테니 계열사를 합쳐서 이전하라는 오퍼가 왔다. 어떻게 접근할 것인가?'
                      }
                      autoSize={{ minRows: 2, maxRows: 4 }}
                    />
                  </Form.Item>
                  {fields.length > 1 && field.name >= 2 ? (
                    <Button className='list-minus-button' onClick={() => remove(field.name)}>
                      <MinusOutlineIcon fill={PrimaryColor} />
                    </Button>
                  ) : null}
                </StyledQuestion>
              ))}
            </StyledQuestionList>
            {/* 추후 질문 리스트 2개 이상으로 늘어날 경우에 주석 풀기 */}
            {/* <Button className='list-plus-button' onClick={() => add()}>
              <PlusOutlineIcon fill={PrimaryColor} />
            </Button> */}

            <Form.ErrorList errors={errors} />
          </StyledQuestionListFormContainer>
        )}
      </Form.List>
    </InterviewQuestionsInputWrapper>
  );
};

export default InterviewQuestionsInput;

const InterviewQuestionsInputWrapper = styled.div`
  margin-bottom: 20px;
  & .ant-form-item {
    margin: 0;
    width: 100%;
  }
  & .ant-btn.list-minus-button,
  .ant-btn.list-plus-button {
    margin: 0;
  }
`;

const StyledQuestionListFormContainer = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
`;

const StyledQuestionList = styled.div`
  width: 98%;
`;

const StyledQuestion = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
`;
